const EDIT_TYPE = {
    CREATE: 'CREATE',
    EDIT: 'EDIT',
    COPY: 'COPY',
    ADD_EFFECT: 'ADD_EFFECT',
};

export default EDIT_TYPE;
